import {
  createContext,
  type ReactNode,
  useContext,
  useEffect,
  useState,
} from 'react'

import { CacheAdapter } from '@/shared/infra'

interface AutocompleteContextProps {
  autocompleteValue: string
  setAutocompleteValue: (value: string) => void
}

const AutocompleteContext = createContext<AutocompleteContextProps | undefined>(
  undefined,
)

export const AutocompleteProvider = ({ children }: { children: ReactNode }) => {
  const [autocompleteValue, setAutocompleteValue] = useState<string>('')

  useEffect(() => {
    const savedValue = CacheAdapter.get('autocompleteValue')
    if (Object.keys(savedValue).length > 0) {
      setAutocompleteValue(savedValue)
    }
  }, [])

  useEffect(() => {
    CacheAdapter.set('autocompleteValue', { autocompleteValue })
  }, [autocompleteValue])

  return (
    <AutocompleteContext.Provider
      value={{ autocompleteValue, setAutocompleteValue }}
    >
      {children}
    </AutocompleteContext.Provider>
  )
}

export const useMapAutocompleteContext = (): AutocompleteContextProps => {
  const context = useContext(AutocompleteContext)
  if (!context) {
    throw new Error(
      'useMapAutocompleteContext must be used within an AutocompleteProvider',
    )
  }
  return context
}
